import React from "react";
import styled from "styled-components";
import config from "../../../../../config/customers";
import { ContainerCss, Devices } from "../../styles";
import SignInButton from "./components/SignInButton";
import Subtitle from "./components/Subtitle";
import Title from "./components/Title";

const Container = styled.section`
  ${ContainerCss};
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 12px;
  background-color: #ffffff;
  padding-top: 2rem;
  padding-bottom: 2rem;
  @media ${Devices.desktop} {
    flex-direction: row;
    gap: 40px;
    padding-top: 3.875rem;
    padding-bottom: 3.875rem;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

const {
  publicPortal: { mainSection },
} = config;

const MainSection = () => {
  return (
    <Container>
      <SignInButton to={mainSection.buttonLink}>
        {mainSection.buttonText}
      </SignInButton>
      <TitleContainer>
        <Title>{mainSection.title}</Title>
        <Subtitle>{mainSection.subtitle}</Subtitle>
      </TitleContainer>
    </Container>
  );
};

export default MainSection;
